import { AdvicePopper } from 'components/AdvicePopper';

export const ObjectPopper = (
  <AdvicePopper
    accordions={[
      {
        details: `Pour optimiser l'affichage de l'objet, celui-ci doit comporter entre 30 et 50 caractères sur mobile et entre 50 et 100 caractères sur Desktop.\nEmployez les mots-clés les plus importants en début d'objet.`,
        summary: 'Objet supérieur à 30 caractères',
      },
    ]}
    title="Conseil de saisie"
  />
);

export const PreHeaderPopper = (
  <AdvicePopper
    accordions={[
      {
        details: `Pour optimiser l'affichage de pré-header, celui-ci doit comporter entre 30 et 50 caractères sur mobile et entre 50 et 100 caractères sur Desktop.\nEmployez les mots-clés les plus importants en début de pré-header.`,
        summary: 'Pré-header supérieur à 30 caractères',
      },
    ]}
    title="Conseil de saisie"
  />
);
